var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tile is-parent is-half" },
    [
      _c("article", { staticClass: "tile is-child box" }, [
        _c("div", { staticClass: "columns is-gapless" }, [
          _vm._m(0),
          _c("div", { staticClass: "column" }, [
            !_vm.readOnly
              ? _c(
                  "form",
                  {
                    ref: "uploader",
                    attrs: { enctype: "multipart/form-data", novalidate: "" },
                  },
                  [
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "div",
                        { staticClass: "file is-pulled-right is-primary" },
                        [
                          _c("label", { staticClass: "file-label" }, [
                            _c("input", {
                              staticClass: "file-input",
                              attrs: {
                                type: "file",
                                name: _vm.uploadFieldName,
                                disabled: _vm.isSaving || _vm.readOnly,
                                accept: "image/png, image/jpeg, .pdf",
                              },
                              on: {
                                change: function ($event) {
                                  _vm.filesChange(
                                    $event.target.name,
                                    $event.target.files
                                  )
                                  _vm.fileCount = $event.target.files.length
                                },
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "file-cta",
                                class: `has-file-btn-text-${_vm.$theme.name}`,
                              },
                              [
                                _vm._m(1),
                                _c("span", { staticClass: "file-label" }, [
                                  _vm._v(" Select files... "),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
        !_vm.readOnly
          ? _c(
              "table",
              {
                staticClass:
                  "table is-bordered is-striped is-narrow is-fullwidth",
              },
              [
                _vm._m(2),
                _c(
                  "tbody",
                  _vm._l(_vm.attachments, function (item) {
                    return _c("tr", { key: item.id }, [
                      _c("td", { staticClass: "has-vertical-middle" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$filters.formatDateTimeLocale(
                                item.createdDate,
                                _vm.$userInfo.locale
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c("td", { staticClass: "has-vertical-middle" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.downloadAttachment(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.fileName))]
                        ),
                      ]),
                      _c("td", { staticClass: "has-vertical-middle" }, [
                        _vm._v(" " + _vm._s(item.fileSize) + " "),
                      ]),
                      _c(
                        "td",
                        {
                          staticClass: "has-vertical-middle has-text-centered",
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "button is-danger is-inverted",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteAttachment(item)
                                },
                              },
                            },
                            [_vm._m(3, true)]
                          ),
                        ]
                      ),
                    ])
                  }),
                  0
                ),
              ]
            )
          : _c(
              "table",
              {
                staticClass:
                  "table is-bordered is-striped is-narrow is-fullwidth",
              },
              [
                _vm._m(4),
                _c(
                  "tbody",
                  _vm._l(_vm.attachments, function (item) {
                    return _c("tr", { key: item.id }, [
                      _c("td", { staticClass: "has-vertical-middle" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$filters.formatDateTimeLocale(
                                item.createdDate,
                                _vm.$userInfo.locale
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c("td", { staticClass: "has-vertical-middle" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.downloadAttachment(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.fileName))]
                        ),
                      ]),
                      _c("td", { staticClass: "has-vertical-middle" }, [
                        _vm._v(" " + _vm._s(item.fileSize) + " "),
                      ]),
                    ])
                  }),
                  0
                ),
              ]
            ),
      ]),
      _vm.currentAttachment
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.confirmDelete(true)
                },
                cancel: function ($event) {
                  return _vm.confirmDelete(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Delete Attachment"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [_vm._v(_vm._s(_vm.currentAttachment.fileName))]
                  ),
                  _vm._v(" will be deleted. Continue? "),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Attachments")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "file-icon" }, [
      _c("i", { staticClass: "mdi mdi-upload mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v(" Date ")]),
        _c("th", [_vm._v(" File name ")]),
        _c("th", [_vm._v(" File size ")]),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-medium" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v(" Date ")]),
        _c("th", [_vm._v(" File name ")]),
        _c("th", [_vm._v(" File size ")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }